import React from 'react'
import htmlParser from 'html-react-parser'

import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'

import useModal from 'hooks/useModal'
import Modal from '../modal'

import { institutions } from 'lib/institutions'

function Institution({
  name,
  isMobile,
  floatRight,
  currentItem,
  currentPlace,
  updatePlace
}) {
  const institution = institutions.find(el => el.name === name)

  const gmaps = 'https://www.google.ch/maps/search/'
  let positions = []

  const size = isMobile ? 'small' : 'medium'
  const float = floatRight ? 'right' : 'left'

  const [isShowing, toggle] = useModal()

  if (institution.positions && institution.positions.length > 0) {
    positions = institution.positions.map(p => {
      return (
        <span
          key={p.displayName}
          onMouseOver={() => {
            updatePlace(p.displayName)
          }}
          onMouseOut={() => updatePlace(null)}
          className={`place ${
            currentPlace === p.displayName ? 'active-place' : null
          }`}
        >
          <a
            href={gmaps + p.position}
            target='_blank'
            rel='noopener noreferrer'
          >
            <i className='external alternate icon' />
            {institution.address}
          </a>
        </span>
      )
    })
  }

  return (
    <div
      className='item-element-text ui huge message'
      style={{
        outline:
          currentItem === name ? 1 + 'px solid ' + institution.color.hex : ''
      }}
    >
      <h4>
        <i className={`small fitted ${institution.color.css} circle icon`} />
        {'  '}
        <span className='item-element-title'>
          {htmlParser(institution.displayName)}
        </span>
      </h4>

      {institution.image && (
        <img
          className={`ui ${size} ${float} floated image item-element-image`}
          src={institution.image}
          onClick={toggle}
        />
      )}

      <div className='item-text'>
        {htmlParser(institution.text)}
        <div>
          <br />
          <b>{positions.length > 1 ? 'Standorte:' : 'Standort:'}</b>
          {positions}
        </div>
      </div>
      <Modal
        image={institution.image}
        isShowing={isShowing}
        hide={toggle}
        name=''
        position=''
      />
    </div>
  )
}

export default Institution
